import { render, staticRenderFns } from "./PayoutsLinks.vue?vue&type=template&id=15b8f892&scoped=true"
import script from "./PayoutsLinks.vue?vue&type=script&lang=js"
export * from "./PayoutsLinks.vue?vue&type=script&lang=js"
import style0 from "./PayoutsLinks.vue?vue&type=style&index=0&id=15b8f892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8f892",
  null
  
)

export default component.exports